// extracted by mini-css-extract-plugin
export default {"wrap":"PageCoverStyle_wrap__ClxoJ","doubleHeaderWrap":"PageCoverStyle_doubleHeaderWrap__MEv8X","full":"PageCoverStyle_full__aRtPJ"};